import React from "react";
import { Navigate } from "react-router-dom";
import AISalesLeadsPage from "./AISalesLeadsPageV2";
import { useCrmHubEnabled } from "../../../utils/useCrmHubEnabled";

/** When CRM Hub is on for this package, bounce legacy leads URL into Hub. */
export default function AISalesLeadsRoute() {
  const crmHubEnabled = useCrmHubEnabled();
  if (crmHubEnabled) {
    return <Navigate to="/p/dashboard/drafts?tab=leads" replace />;
  }
  return <AISalesLeadsPage />;
}
